/**
 * Formats a file size in bytes into a human-readable string (MB or GB)
 * @param bytes - The file size in bytes
 * @returns A formatted string with appropriate unit (MB or GB)
 */
export const formatFilesize = (bytes?: number | null): string => {
  if (!bytes || bytes <= 0) return "--";
  const gb = bytes / (1024 ** 3);
  if (gb >= 1) return `${gb.toFixed(2)} GB`;
  const mb = bytes / (1024 ** 2);
  return `${mb.toFixed(2)} MB`;
};
